import makeApiCall from "../master/axiosIndex";

const STATIC_FILES_DATA = {
  docKeys: [
    {
      order: 0,
      module: "Purchase Return",
      moduleFileType: "signature.png",
    },
  ],
};

const returnsApis = {
  fetchAllReturnsWithPagination: (params: any): Promise<any> =>
    makeApiCall<any>({
      url: "/return/list",
      method: "get",
      params,
    }),
  fetchAllPendingApprovalReturnsWithPagination: (params: any): Promise<any> =>
    makeApiCall<any>({
      url: "/return/pending-approvals",
      method: "get",
      params,
    }),
  fetchReturn: (id: string): Promise<any> =>
    makeApiCall<any>({
      url: `/return/id/${id}`,
      method: "get",
    }),
  approveReturn: (returnNumber: number, files: File[] = []): Promise<any> => {
    const formData = new FormData();

    const requestBody = {
      returnNumber,
      filesData: STATIC_FILES_DATA,
    };

    formData.append("request", JSON.stringify(requestBody));
    files.forEach((file) => formData.append("files", file));

    return makeApiCall<any>({
      method: "patch",
      url: `/return/approve`,
      data: formData,
    });
  },

  rejectReturn: (returnNumber: number, reason: string, files: File[] = []): Promise<any> => {
    const formData = new FormData();

    const requestBody = {
      returnNumber,
      reason,
      filesData: STATIC_FILES_DATA,
    };

    formData.append("request", JSON.stringify(requestBody));
    files.forEach((file) => formData.append("files", file));

    return makeApiCall<any>({
      method: "patch",
      url: `/return/reject`,
      data: formData,
    });
  },
};

export default returnsApis;
